import { FC, useState } from "react";
import Colors from "~/constants/colors";
import Icon from "../Icon";
import styles from "./Star.module.scss";
import { getConfig } from "~/utils/theme";

interface StarProps {
  size?: number;
  star?: number;
  colorInActive?: string;
  colorActive?: string;
  value?: number;
  onChange?: (value: number) => void;
  isEdit?: boolean;
}

const Star: FC<StarProps> = (props) => {
  const themeConfig = getConfig("Common");
  const {
    size = 24,
    star = 5,
    colorInActive = Colors.GREY_100,
    colorActive = themeConfig.starActiveColor,
    value = 0,
    onChange,
    isEdit,
  } = props;
  const [hoverIndex, setHoverIndex] = useState(0);

  return (
    <div className={styles.star}>
      {Array(star)
        .fill({})
        .map((_, i) => {
          const isActive = i < value || i < hoverIndex;

          return (
            <Icon
              key={i}
              name={isActive ? "star-2" : "star"}
              size={size}
              color={isActive ? colorActive : colorInActive}
              className={styles.star_item}
              style={{ width: size, height: size }}
              onMouseEnter={() => isEdit && setHoverIndex(i + 1)}
              onMouseLeave={() => isEdit && setHoverIndex(0)}
              onClick={() => isEdit && onChange?.(i + 1)}
            />
          );
        })}
    </div>
  );
};

export default Star;
